import { AfterViewInit, Component, ElementRef, Injector, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Shared
import { ONBOARDING_CARD_ENUMERATION } from '../shared';

const REDIRECT_TO_TERMS_CONSTANT = '/card-terms-and-conditions';
@Component({
  selector: 'app-card-explain',
  templateUrl: './card-explain.component.html',
})
export class CardExplainComponent implements AfterViewInit, OnDestroy {
  @ViewChild('onboardingViews', { static: false }) public onboardingViews: ElementRef;

  private readonly webComponentService: WebcomponentsService;
  private router: Router;
  private readonly unSubscribe$: Subject<void>;
  private readonly ngZone: NgZone;

  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.unSubscribe$ = new Subject<void>();
    this.ngZone = this.injector.get(NgZone);
  }

  public ngAfterViewInit(): void {
    this.renderOnboardingViews();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderOnboardingViews(): void {
    const creditList = this.onboardingViews.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          creditList.ngElementStrategy?.componentRef?.instance?.build({
            onboardingView: ONBOARDING_CARD_ENUMERATION.CARD_EXPLAIN,
            continueActionFn: this.continueAction.bind(this),
          });
        }
      },
    });
  }

  public continueAction(): void {
    this.ngZone.run(() => {
      this.router.navigate([REDIRECT_TO_TERMS_CONSTANT]);
    });
  }
}
